import { render, staticRenderFns } from "./projectCard.vue?vue&type=template&id=72ce3514&scoped=true&"
import script from "./projectCard.vue?vue&type=script&lang=js&"
export * from "./projectCard.vue?vue&type=script&lang=js&"
import style0 from "./projectCard.vue?vue&type=style&index=0&id=72ce3514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ce3514",
  null
  
)

export default component.exports